import { render, staticRenderFns } from "./block-document-field-toolbar.vue?vue&type=template&id=2a8646c8&scoped=true&lang=pug"
import script from "./block-document-field-toolbar.vue?vue&type=script&lang=js"
export * from "./block-document-field-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8646c8",
  null
  
)

export default component.exports